import cn from 'classnames';
import Div from 'components/common/Div';
import Img from 'components/common/Img';
import Loading from 'components/common/loaders/Loading';
import ShowIf from 'components/common/ShowIf';
import { useRouter } from 'hooks/useRouter';
import React, { useEffect, useRef, useState } from 'react';
import { icCloseMemberModal, loadingGreen } from 'redhotpie-shared-lib/themes/ImagesSVG';
import Modal, { IModalComponentProps } from '../Modal/Modal';
import './styles.scss';

interface BrowserModalProps extends IModalComponentProps {
  widthMax500?: boolean;
  url?: string;
  isHideLoadingBrowserModal?: boolean;
  customClassContainer?: string;
}

const BrowserModal: React.FC<BrowserModalProps> = props => {
  const { showModal, widthMax500, url = 'https://www.google.com.vn/', isHideLoadingBrowserModal, customClassContainer } = props;
  const refModal = useRef<any>(null);
  const [disableLoading, setDisableLoading] = useState(false);
  const { history, location } = useRouter();

  function closeModal(cb?: () => void) {
    refModal.current?.closeModal(cb);
  }

  useEffect(() => {
    if (disableLoading && !showModal) {
      setDisableLoading(false);
    }
  }, [showModal, disableLoading]);

  const renderBrowserModal = () => {
    const customClass = cn('browser-modal-container', {
      'width-max500': widthMax500,
    });
    return (
      <React.Fragment>
        <Div className="__icon-close" onClick={() => closeModal()}>
          <Img src={icCloseMemberModal} alt="close-member-modal" />
        </Div>
        <div
          className={cn('modal-container', {
            [customClassContainer || '']: customClassContainer,
          })}>
          <div className={customClass}>
            <ShowIf condition={!url && !isHideLoadingBrowserModal}>
              <Loading icon={loadingGreen} />
            </ShowIf>
            <ShowIf condition={!!url}>
              <div className={cn('full-height', { 'holds-the-iframe': !disableLoading })}>
                <iframe src={url} frameBorder={0} onLoad={() => setDisableLoading(true)} title="browser-modal-iframe" />
              </div>
            </ShowIf>
          </div>
        </div>
      </React.Fragment>
    );
  };

  return <Modal {...props} history={history} location={location} ref={refModal} modalName="BrowserModal" childHook={renderBrowserModal} />;
};

export default BrowserModal;
